import React, { createContext, useContext, useState, ReactNode } from "react";

type ServiceTab = "mobile" | "digitalSecurity" | "fixedPhone" | null;

interface ServiceTabContextType {
  dashboardActiveTab: ServiceTab;
  simServiceActiveTab: ServiceTab;
  setDashboardActiveTab: (tab: ServiceTab) => void;
  setSimServiceActiveTab: (tab: ServiceTab) => void;
}

const ServiceTabContext = createContext<ServiceTabContextType | undefined>(
  undefined
);

export const ServiceTabProvider = ({ children }: { children: ReactNode }) => {
  const [dashboardActiveTab, setDashboardActiveTabState] = useState<ServiceTab>(
    () => {
      return (
        (sessionStorage.getItem("dashboardActiveTab") as ServiceTab) || null
      );
    }
  );
  const [simServiceActiveTab, setSimServiceActiveTabState] =
    useState<ServiceTab>(() => {
      return (
        (sessionStorage.getItem("simServiceActiveTab") as ServiceTab) || null
      );
    });

  const setDashboardActiveTab = (tab: ServiceTab) => {
    setDashboardActiveTabState(tab);
    if (tab) {
      sessionStorage.setItem("dashboardActiveTab", tab);
    } else {
      sessionStorage.removeItem("dashboardActiveTab");
    }
  };

  const setSimServiceActiveTab = (tab: ServiceTab) => {
    setSimServiceActiveTabState(tab);
    if (tab) {
      sessionStorage.setItem("simServiceActiveTab", tab);
    } else {
      sessionStorage.removeItem("simServiceActiveTab");
    }
  };

  return (
    <ServiceTabContext.Provider
      value={{
        dashboardActiveTab,
        simServiceActiveTab,
        setDashboardActiveTab,
        setSimServiceActiveTab,
      }}
    >
      {children}
    </ServiceTabContext.Provider>
  );
};

export const useServiceTab = () => {
  const context = useContext(ServiceTabContext);
  if (context === undefined) {
    throw new Error("useServiceTab must be used within a ServiceTabProvider");
  }
  return context;
};

export const DashboardTabProvider = ServiceTabProvider;
export const useDashboardTab = () => {
  const { dashboardActiveTab, setDashboardActiveTab } = useServiceTab();
  return { activeTab: dashboardActiveTab, setActiveTab: setDashboardActiveTab };
};

export const useSimServiceTab = () => {
  const { simServiceActiveTab, setSimServiceActiveTab } = useServiceTab();
  return {
    activeTab: simServiceActiveTab,
    setActiveTab: setSimServiceActiveTab,
  };
};
